import { render, staticRenderFns } from "./StandardWorkInstructionView.vue?vue&type=template&id=74c785e7&scoped=true"
import script from "./StandardWorkInstructionView.vue?vue&type=script&lang=js"
export * from "./StandardWorkInstructionView.vue?vue&type=script&lang=js"
import style0 from "./StandardWorkInstructionView.vue?vue&type=style&index=0&id=74c785e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c785e7",
  null
  
)

export default component.exports